import { bootstrapApplication } from '@angular/platform-browser';
import { init, ErrorEvent as SentryErrorEvent } from '@sentry/angular';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

function getSentryEnvironment(): string {
  if (environment.production) return 'production';
  if (environment.staging) return 'staging';
  return 'development';
}

const SVG_ICON_LOAD_FAILURE_PATTERN =
  /Http failure response for .*\/assets\/icon\/.*\.svg: 0/;
const MOODLE_IFRAME_ROUTE_PATTERNS = [
  /\/content(?:[/?#]|$)/,
  /\/lms(?:[/?#]|$)/,
  /\/learners(?:[/?#]|$)/,
];

function isIgnorableMoodleIframeNg0904(event: SentryErrorEvent): boolean {
  const message = event.message ?? event.exception?.values?.[0]?.value ?? '';
  if (!message.includes('NG0904')) {
    return false;
  }

  const url = event.request?.url ?? '';
  return MOODLE_IFRAME_ROUTE_PATTERNS.some(pattern => pattern.test(url));
}

if (environment.sentryDsn) {
  init({
    dsn: environment.sentryDsn,
    environment: getSentryEnvironment(),
    integrations: [],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    ignoreErrors: [SVG_ICON_LOAD_FAILURE_PATTERN],
    beforeSend(event: SentryErrorEvent) {
      return isIgnorableMoodleIframeNg0904(event) ? null : event;
    },
  });
  console.log(`Sentry initialized for ${getSentryEnvironment()} environment`);
} else {
  console.log(
    `Sentry not initialized — no DSN configured for ${getSentryEnvironment()} environment`
  );
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
